import CardOrder from '@/models/CardOrder'

export default function (value) {
  const cardTypeOption = CardOrder.cardTypeOptions.find(
    cardTypeOption => cardTypeOption.value === value
  )

  return cardTypeOption != null ? cardTypeOption.name : value
}
